import { render } from "./CommunitySelect.vue?vue&type=template&id=47a42d0f&scoped=true"
import script from "./CommunitySelect.vue?vue&type=script&lang=js"
export * from "./CommunitySelect.vue?vue&type=script&lang=js"

import "./CommunitySelect.vue?vue&type=style&index=0&id=47a42d0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a42d0f"]])

export default __exports__